import React from 'react';

import { SimpleAnyObject } from '@clearverify/types';

export type InboxFilterContextValue = {
  filterFormValues: SimpleAnyObject;
  setFilterFormValues: React.Dispatch<React.SetStateAction<SimpleAnyObject>>;
};

export const DEFAULT_INBOX_FILTER_CONTEXT: InboxFilterContextValue = {
  filterFormValues: {},
  setFilterFormValues: () => undefined,
};

export const InboxFilterContext = React.createContext(DEFAULT_INBOX_FILTER_CONTEXT);
